module.exports = __webpack_public_path__ + "static/img/zug_rund.fa696f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zug_rund.jpg
// module id = wMLQ
// module chunks = 1